var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [_vm.isMobile ? _c("react-mount-home") : _c("fast-action-component")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }